var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63451 1.07757C9.86716 0.974143 10.1328 0.974143 10.3655 1.07757L18.4655 4.67757C18.7906 4.82202 19 5.14433 19 5.5V14.5C19 14.8557 18.7906 15.178 18.4655 15.3224L10.3655 18.9224C10.1328 19.0258 9.86716 19.0258 9.63451 18.9224L1.53447 15.3224C1.20946 15.178 1 14.8557 1 14.5V5.5C1 5.14433 1.20946 4.82202 1.53447 4.67757L9.63451 1.07757ZM10.9 16.7151L17.2 13.9151V6.88488L14.9499 7.88493V10.45C14.9499 10.9471 14.547 11.35 14.0499 11.35C13.5528 11.35 13.1499 10.9471 13.1499 10.45V8.68492L10.9 9.68491V16.7151ZM10 8.11511L11.8866 7.27664L6.17069 4.58681L4.11599 5.5L10 8.11511ZM8.34472 3.62055L14.0606 6.31038L15.884 5.5L10 2.88489L8.34472 3.62055Z",
    fill: "#D42124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage1);
export default __webpack_public_path__ + "static/media/package1.470b13dd2e40698b24c1dcf14b2faac2.svg";
export { ForwardRef as ReactComponent };